import {getCookie} from "./helpers";

(function() {
    const search_params = new URLSearchParams(window.location.search);
    const cookie_settings = ' path=/; domain=' + document.location.hostname + '; max-age=2592000' + "; Secure; SameSite=Strict";

    if (!search_params.get('ndl') && search_params.get('utm_source') && !getCookie('target_url_write')) {
        document.cookie = 'target_url=' + window.location.href + ';' + cookie_settings;
        document.cookie = 'target_url_write = 1; path=/; domain=' + document.location.hostname + '; max-age=60' + "; Secure; SameSite=Strict";
    }

    if (!search_params.get('utm_source') && !getCookie('target_url')) {
        if (document.referrer.indexOf('google') >= 0) {
            document.cookie = 'target_url = ' + window.location.origin + '/?utm_source=google&utm_medium=organic&utm_campaign=organic;' + cookie_settings;
        } else if (document.referrer == '' || document.referrer.indexOf(window.location.hostname) >= 0) {
            document.cookie = 'target_url = ' + window.location.origin + '/?utm_source=direct&utm_medium=none&utm_campaign=direct;' + cookie_settings;
        } else {
            let referrer = new URL(document.referrer).hostname;

            if (referrer.substring(0, 4) === 'www.') {
                referrer = referrer.substring(4);
            }
            document.cookie = 'target_url = ' + window.location.origin + '/?utm_source=referral&utm_medium=referral&utm_campaign=' + referrer + ';' + cookie_settings;
        }
    }
})();

// Open new window from webview
(function () {
    const browserOpenLinks = document.querySelectorAll('[data-webview]');

    if (browserOpenLinks) {
        browserOpenLinks.forEach(link => {
            link.addEventListener('click', e => {
                e.preventDefault();

                const userAgent = navigator.userAgent || navigator.vendor;
                const targetUrl = getCookie('target_url')
                const paramsUrl = targetUrl.split('?');

                const webviewRedirect = (fu) => {
                    window.location.href = `intent:${fu}#Intent;end`
                    setTimeout(() => window.location.href = fu, 3000)
                }

                const iosWebviewRedirect = (su, fu) => {
                    window.location.href = `googlechrome://${su}`
                    setTimeout(() => window.location.href = fu, 3000)
                }

                if (link.href) {
                    const fullUrl = `${link.href}?${paramsUrl[1]}`
                    const shortUrl = `${link.href.slice(8)}?${paramsUrl[1]}`

                    if (/iPad|iPhone/.test(userAgent)) {
                        iosWebviewRedirect(shortUrl, fullUrl)
                    }

                    webviewRedirect(fullUrl)
                }
            });
        });
    }
}());
